<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon="mdi-form-textbox" title="Opsiyon Yönetimi" desc="API ve Modüler opsiyonların yönetim alanı" />
      </v-col>
      <v-col cols="12" lg="6">
        <panel-title h="h4" icon="mdi-folder-text-outline" icon-color="grey darken-2" text-color="grey--text text--darken-3" title="Opsiyon Türünü Seçin" weight="regular" />
        <v-select solo :items="optionTypes" height="25" dense @change="getOptions" v-model="optionData.optionType" return-object>
          <template v-slot:item="{ item }">
            <span>
              <span class="mr-1 text-body-2">{{ item.text }}</span>
              <v-chip v-if="item.type === 'Api'" x-small color="primary" dark>{{ item.type }}</v-chip>
              <v-chip v-else-if="item.type === 'Modules'" x-small color="blue" dark>{{ item.type }}</v-chip>
            </span>
          </template>
          <template v-slot:selection="{ item }">
            <span>
              <span class="mr-1 text-subtitle-2">{{ item.text }}</span>
              <v-chip v-if="item.type === 'Api'" x-small color="primary" dark>{{ item.type }}</v-chip>
              <v-chip v-else-if="item.type === 'Modules'" x-small color="blue" dark>{{ item.type }}</v-chip>
            </span>
          </template>
        </v-select>
        <panel-title h="h4" icon="mdi-format-list-bulleted-square" icon-color="grey darken-2" text-color="grey--text text--darken-3" title="Opsiyon Listesi" weight="regular">
          <template v-slot:append-inner>
            <add-option />
          </template>
        </panel-title>
        <options-list v-model="optionData.optionsList" @change="updateOptionsQueue" @input-list="getInputList" @delete-option="optionDeleted" />
      </v-col>
      <v-col cols="12" lg="6">
        <panel-title h="h4" icon="mdi-form-textarea" icon-color="grey darken-2" text-color="grey--text text--darken-3" :title="isOptActive ? `İnput Listesi ( ${activeOption.name} )` : 'İnput Listesi'" weight="regular">
          <template v-slot:append-inner>
            <AddInput v-if="isOptActive" />
          </template>
        </panel-title>
        <inputs-list v-if="optionData.optionSysNameForList" v-model="inputData.inputsList" @change="updateInputsQueue" />
        <p v-else class="text-center subtitle-2 grey--text text--darken-1 grey lighten-2 py-3">
          Opsiyon seçimi yapınız
        </p>

        <p v-if="optionData.optionSysNameForList && inputData.inputsList.length == 0" class="d-flex justify-center align-center text-center subtitle-2 orange--text text--darken-3 grey lighten-2 py-3">
          <v-icon size="20" color="orange darken-3" left>mdi-minus-circle-outline </v-icon>
          Opsiyon üzerinde Input girişi tanımlaması yapılmadı
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PanelTitle from "@/components/PanelTitle.vue";
import { mapState } from "vuex";
import AddOption from "../../../components/Developer/Options/AddOption.vue";
import OptionsList from "../../../components/Developer/Options/OptionsList.vue";
import InputsList from "../../../components/Developer/Options/InputsList.vue";
import AddInput from "../../../components/Developer/Options/AddInput.vue";

export default {
  components: { PanelTitle, AddOption, OptionsList, InputsList, AddInput },
  name: "DeveloperOptions",
  data: () => ({
    optionTypes: [
      {
        text: "API",
        value: "",
        type: "Api"
      }
    ],
    optionModule: [],

    /**
     * Opsiyon v-model
     */
    optionData: {
      optionType: {}, // Seçilen opsiyon type
      optionSysNameForList: false, // Input list seçimi ile hangi opsiyonun seçildiği
      optionsList: [] // Seçili type'ın opsiyon listesi
    },

    inputData: {
      inputsList: []
    },

    /**
     * Opsiyonlar için types
     */
    types: {
      apiType: "Api",
      modulesType: "Modules",
      pluginsType: "Plugins"
    }
  }),
  computed: {
    ...mapState({
      moduleList: state => state.Module.ModulesList.getModulesList,
      activeOption: state => state.Option.option,
      activeOptionType: state => state.Option.optionType,
      apiLanguage: state => state.Language.apiLanguage
    }),
    optionList() {
      return this.$store.state.Option[this.optionStoreModule()].optionList;
    },
    inputList() {
      return this.$store.state.Option[this.optionStoreModule()].inputList;
    },
    optionType() {
      let opt = this.getOptionType();
      return opt.optionType;
    },
    optionName() {
      let opt = this.getOptionType();
      return opt.optionName;
    },
    isOptActive() {
      return !!Object.keys(this.activeOption).length;
    }
  },
  methods: {
    /**
     * İlgili option türüne ait olan option
     * listesini getirir.
     */
    getOptions() {
      let self = this,
        opt = { ...self.getOptionType(), lang: this.apiLanguage };

      this.optionData.optionSysNameForList = false;

      self.$store
        .dispatch(self.optionStore() + "getOptionList", opt)
        .then(res => {
          self.$store.commit("Option/setOption", {});
          self.$store.commit("Option/setOptionType", opt);
          return res;
        })
        .then(res => {
          if (res.status === 200) {
            self.optionData.optionsList = res.data;
          }
        });
    },
    /**
     * İlgili option ve type'a göre input listesini verir
     */
    getInputList(optionSysName) {
      let self = this,
        opt = { ...self.getOptionType(), lang: this.apiLanguage },
        dispatch = self.optionStore() + "getInputList",
        optDispatch = self.optionStore() + "option";

      this.optionData.optionSysNameForList = optionSysName;
      opt["optionSysName"] = optionSysName;

      self.$store.dispatch(optDispatch, opt).then(res => {
        if (res.status === 200) {
          self.$store.commit("Option/setOption", res.data);

          self.$store.dispatch(dispatch, opt).then(res => {
            if (res.status === 200) {
              self.inputData.inputsList = res.data;
            }
          });
        }
      });
    },
    /**
     * { optionType, optionName } değerlerini verir
     *
     * @returns {object}
     */
    getOptionType() {
      let getOpt = this.optionData.optionType;
      const optionType = getOpt.type,
        optionName = getOpt.value;
      return { optionType, optionName };
    },
    /**
     * Seçilen type'a göre Option Modülünün namespace'ini
     * döndürür.
     *
     * @returns {string}
     */
    optionStore() {
      let opt = this.getOptionType(),
        optionStore = "";

      if (opt.optionType == this.$moduleTypes.apiType) {
        optionStore = "Option/ApiOptions/";
      } else if (opt.optionType == this.$moduleTypes.modulesType) {
        optionStore = "Option/ModuleOptions/";
      } else if (opt.optionType == this.$moduleTypes.pluginsType) {
        optionStore = "Option/PluginOptions/";
      }

      return optionStore;
    },
    optionStoreModule() {
      let opt = this.getOptionType(),
        optionStore = "";

      if (opt.optionType == this.$moduleTypes.apiType) {
        optionStore = "ApiOptions";
      } else if (opt.optionType == this.$moduleTypes.modulesType) {
        optionStore = "ModuleOptions";
      } else if (opt.optionType == this.$moduleTypes.pluginsType) {
        optionStore = "PluginOptions";
      }

      return optionStore;
    },
    /**
     * Option listesin drag işleminden sonra günceleme
     * yap
     */
    updateOptionsQueue() {
      let opt = this.getOptionType();
      opt.optsList = this.optionData.optionsList;

      this.$store.dispatch(this.optionStore() + "updateOptionsQueue", opt).then(res => {
        if (res.status === 200) {
          this.$snotify.success("Opsiyon listesi güncellendi", this.$t('PANEL.NOTIFY.SUCCESS'));
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
      });
    },
    /**
     * Input listesini drag işleminden sonra günceleme
     * yap
     */
    updateInputsQueue() {
      let inputsList = this.inputData.inputsList;

      this.$store.dispatch(this.optionStore() + "updateInputsQueue", { inputsList }).then(res => {
        if (res.status === 200) {
          this.$snotify.success("Input listesi güncellendi", this.$t('PANEL.NOTIFY.SUCCESS'));
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
      });
    },
    optionDeleted() {
      this.optionData.optionSysNameForList = false;
    }
  },
  created() {
    let self = this;

    this.$store.commit("Option/ModuleOptions/setLang", this.apiLanguage);
    this.$store.commit("Option/ApiOptions/setLang", this.apiLanguage);

    /**
     * Modül listesini getir ve türlerin içerisine dahil et
     */
    this.$store.dispatch("Module/ModulesList/getModulesList").then(res => {
      if (res.status === 200) {
        let moduleOptions = res.data;
        for (let o in moduleOptions) {
          self.optionTypes.push({
            text: moduleOptions[o].name,
            value: moduleOptions[o].name,
            type: self.types.modulesType
          });
        }
      }
    });

    /**
     * Öntanımlı type üzerinden opsiyon listesi getir
     */
    this.optionData.optionType = this.optionTypes[0];

    /**
     * Inputs Features
     */
    this.$store.dispatch("Option/getInputClasses");
  },
  watch: {
    "optionData.optionType"(val) {
      this.getOptions();

      /**
       * -- Option list watcher
       *
       * Listede değişiklik yapıldığı zaman store üzerinde
       * dispatch'ler devreye girer. Sıralamadan dolayı direkt olarak
       * optionList nesnesini optionList'e bağlayamadık.
       *
       * Bu yüzden arka planda olası store üzerindeki değişiklikleri
       * dinler ve alıp gösterimde olan veriyi günceller.
       */
      if (val.type === this.$moduleTypes.apiType) {
        /**
         * Options Store Watcher
         */
        this.$store.watch(
          () => this.$store.state.Option.ApiOptions.optionList,
          optionList => {
            this.optionData.optionsList = optionList;
          }
        );

        /**
         * Input List Store Watcher
         */
        this.$store.watch(
          () => this.$store.state.Option.ApiOptions.inputList,
          inputList => {
            this.inputData.inputsList = inputList;
          }
        );
      } else if (val.type === this.$moduleTypes.modulesType) {
        /**
         * Options Store Watcher
         */
        this.$store.watch(
          () => this.$store.state.Option.ModuleOptions.optionList,
          optionList => {
            this.optionData.optionsList = optionList;
          }
        );

        /**
         * Input List Store Watcher
         */
        this.$store.watch(
          () => this.$store.state.Option.ModuleOptions.inputList,
          inputList => {
            this.inputData.inputsList = inputList;
          }
        );
      } else if (val.type === this.$moduleTypes.pluginsType) {
        /**
         * Options Store Watcher
         */
        this.$store.watch(
          () => this.$store.state.Option.PluginOptions.optionList,
          optionList => {
            this.optionData.optionsList = optionList;
          }
        );

        /**
         * Input List Store Watcher
         */
        this.$store.watch(
          () => this.$store.state.Option.PluginOptions.inputList,
          inputList => {
            this.inputData.inputsList = inputList;
          }
        );
      }
    }
  }
};
</script>
